<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div style="width: 100%">
        <ServiceInfo></ServiceInfo>
        <div class="col-md-10 col-sm-12 m-auto jipvio-rad">
          <!-- 본인인증 -->
          <div class="m-auto">
            <card id="agt_step2_chckPInfo" tabindex="0" class="mt-15;">
              <div slot="header">
                <h3 class="card-title" align="center">의뢰인 정보</h3>
                <h6>
                  <i class="fas fa-exclamation-circle"></i>
                  건축물대장상 소유자와의 일치 여부를 확인하는 절차입니다.
                  소유자인 의뢰인 정보를 입력해주시길 바랍니다.
                </h6>
              </div>
              <div class="row">
                <div class="col-lg-5 fl">
                  <!-- 성명 -->
                  <div class="row m-row">
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >성명</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0">
                      <ValidationProvider
                        ref="clientNameVal"
                        rules="required"
                        v-slot="{ failed }"
                      >
                        <!-- _inputs.scss - .form-control - border-radius: $btn-round-radius 주석처리 하여 inputbox 네모로 만들었음 -->
                        <fg-input
                          ref="clientNameBoxRef"
                          innerRef="clientName_inner"
                          type="text"
                          :error="failed ? '성명을 입력해주세요' : null"
                          placeholder="성명 (required)"
                          v-model="clientName"
                        >
                        </fg-input>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- 휴대전화 -->
                  <div class="row m-row">
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >휴대전화</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0">
                      <!--sohyun 레이아웃 변경-->
                      <ValidationProvider
                        ref="clientTelVal"
                        rules="required|numeric"
                        v-slot="{ failed }"
                      >
                        <fg-input
                          class="r-noradius"
                          ref="clientTelBoxRef"
                          innerRef="clientTel_inner"
                          type="number"
                          :error="
                            failed ? '휴대전화 번호를 입력해주세요' : null
                          "
                          placeholder="휴대전화 (required)"
                          v-model="clientTel"
                        >
                        </fg-input>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="row m-row">
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >소유주 여부</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0">
                      <!--sohyun 레이아웃 변경-->
                      <ValidationProvider
                        ref="clientTelVal"
                        rules="required"
                        v-slot="{ failed }"
                      >
                        <fg-input
                          :error="failed ? '필수 입력 항목입니다!' : null"
                        >
                          <el-radio-group v-model="ownerYn">
                            <el-radio
                              class="mr-0"
                              ref="loanYnButtonRef"
                              label="1"
                              border
                              >예</el-radio
                            >
                            <el-radio class="m-ml-0" label="0" border
                              >아니오</el-radio
                            >
                          </el-radio-group>
                        </fg-input>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <div class="col-lg-7 fl">
                  <div class="row m-row">
                    <!--소유주 주소 -->
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >주소(실거주지)</label
                    >
                    <div class="col-lg-9 col-md-12 col-sm-12 px-0">
                      <div class="fl" style="width: 85%">
                        <ValidationProvider
                          ref="clientAddrVal"
                          rules="required"
                          v-slot="{ failed }"
                        >
                          <!-- 도원씨 작업해주세요!!! 주소검색하고 주소클릭하면, input박스 안에 들어가야하는데, 안들어가요..-->
                          <fg-input
                            class="r-noradius"
                            ref="clientAddrBoxRef"
                            innerRef="clientAddr_inner"
                            type="text"
                            :error="
                              failed ? '소유주 주소를 입력해주세요' : null
                            "
                            placeholder="주소 (required)"
                            v-model="clientAddr"
                          >
                          </fg-input>
                        </ValidationProvider>
                      </div>
                      <div class="fl" style="width: 15%">
                        <el-button
                          class="el-btn-height jip-cont-btn l-noradius"
                          icon="el-icon-search"
                          @click="addressPop"
                        ></el-button>
                      </div>
                    </div>
                  </div>

                  <div class="row m-row">
                    <!-- 소유주 상세주소 -->
                    <label class="col-lg-3 col-md-12 col-form-label px-0"
                      >상세주소</label
                    >

                    <div class="col-lg-9 col-md-12 col-sm-12 px-0">
                      <ValidationProvider
                        ref="clientAddrDetailVal"
                        rules="required"
                        v-slot="{ failed }"
                      >
                        <fg-input
                          ref="clientAddrDetailBoxRef"
                          innerRef="clientAddrDetail_inner"
                          type="text"
                          :error="failed ? '상세주소를 입력해주세요' : null"
                          placeholder="상세주소 (required)"
                          v-model="clientAddrDetail"
                        >
                        </fg-input>
                      </ValidationProvider>
                      <h6 class="mb-0">
                        <i class="fas fa-exclamation-circle"></i>
                        실제 거주하는 곳을 입력해주세요.(전속중개계약서, 계약서
                        작성 시 필요)
                      </h6>
                      <h6>
                        <i class="fas fa-exclamation-circle"></i>
                        도로명, 건물명, 지번에 대해 통합검색이 가능합니다.
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <!-- 전속중개계약서 등록 -->
          <div class="mt-2">
            <card id="agt_step2_contrFileUpl" tabindex="0">
              <div slot="header">
                <h3 class="card-title" align="center">전속중개계약서 등록</h3>
                <h6 class="mb-0">
                  * 전속중개계약서를 스캔한 파일(jpg, png, pdf 형식)을
                  업로드해주시길 바립니다. (전속중개계약서는 공인중개사법 제14조
                  별지 제15호의 법정서식을 따릅니다.)
                </h6>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <!-- 전속중개계약서 업로드 -->
                  <div slot="header">
                    <h3 class="card-title">전속중개계약서 업로드</h3>
                  </div>
                  <div class="col-12 px-0 jvo-upload">
                    <el-upload
                      class="upload-demo text-center"
                      drag
                      :limit="1"
                      :auto-upload="false"
                      action="#"
                      :on-change="uploadChange"
                      :on-remove="removeFile"
                      :on-exceed="exceedFileLimit"
                      :file-list="cont_File.fileList"
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        파일을 여기로 끌어 놓으세요.<br />혹은
                        <em>클릭해주세요.</em>
                      </div>
                      <div class="el-upload__tip" slot="tip">
                        사이즈 500kb 미만의 jpg/png 파일로 제한
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import filestoreApi from "@/service/filestore";

import ServiceInfo from "@/pages/jipvio/GeneralViews/ServiceInfoForAgt.vue";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { createNamespacedHelpers } from "vuex";

extend("required", required);

import {
  Card,
  Checkbox,
  Table,
  TableColumn,
  Button,
  Message,
  Upload,
  RadioGroup,
  Radio
} from "element-ui";

const {
  mapActions: sessionMapActions,
  mapGetters: sessionMapGetters
} = createNamespacedHelpers("loginSession");

export default {
  components: {
    ServiceInfo,
    Card,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Message.name]: Message,
    [Upload.name]: Upload
  },
  data() {
    return {
      ownerAddrInfo: {},
      clientName: null,
      clientTel: null,
      clientAddr: null,
      clientAddrDetail: null,
      ownerYn: null, //소유주 여부
      cont_File: {
        data: null,
        fileList: [],
        idArr: [],
        removedIdArr: []
      }
    };
  },
  created() {
    console.log("AgtStep2 created");
    this.bringData();
  },

  watch: {
    sessionOwnerJuso(newValue, oldValue) {
      this.ownerAddrInfo = newValue;
      this.clientAddr = this.ownerAddrInfo.roadFullAddr;
    }
  },

  computed: {
    ...sessionMapGetters({
      sessionPropertyInquiry: "getPropertyInquiry",
      sessionOwnerJuso: "getOwnerJuso"
    })
  },

  methods: {
    saveStep() {
      this.saveStep2Info();
    },

    ...sessionMapActions(["saveAgtPropertyInquiryStep2"]),

    bringData() {
      console.log("birngDaat");
      console.log(this.sessionPropertyInquiry.certification);
      console.log(this.sessionPropertyInquiry.certification.contFile);

      this.clientName = this.sessionPropertyInquiry.certification.ownerName;
      this.clientTel = this.sessionPropertyInquiry.certification.ownerTel;
      this.clientAddr = this.sessionPropertyInquiry.certification.ownerAddr;
      this.clientAddrDetail = this.sessionPropertyInquiry.certification.ownerAddrDetail;
      this.cont_File = this.sessionPropertyInquiry.certification.contFile;
    },

    saveStep2Info() {
      console.log("Agt step2 save Action!");
      const certification = {
        ownerName: this.clientName,
        ownerAddr: this.clientAddr,
        ownerAddrDetail: this.clientAddrDetail,
        ownerTel: this.clientTel,
        contFile: this.cont_File
      };
      this.saveAgtPropertyInquiryStep2(certification);
      console.log(this.sessionPropertyInquiry);
    },

    async showMessage() {
      let errMsg = [];

      let res = await this.$refs["clientNameVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "의뢰인의 성명을 확인해주세요.",
          focusId: "agt_step2_chckPInfo"
        });
      }

      res = await this.$refs["clientTelVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "의뢰인의 휴대전화를 확인해주세요.",
          focusId: "agt_step2_chckPInfo"
        });
      }

      res = await this.$refs["clientAddrVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "의뢰인의 주소를 입력해주세요.",
          focusId: "agt_step2_chckPInfo"
        });
      }

      res = await this.$refs["clientAddrDetailVal"].validate();
      if (!res.valid) {
        errMsg.push({
          message: "의뢰인의 상세주소를 입력해주세요.",
          focusId: "agt_step2_chckPInfo"
        });
      }

      if (errMsg[0] != null) {
        document.getElementById(errMsg[0].focusId).focus();
        Message({
          message: errMsg[0].message,
          type: "error"
        });
      }

      if (errMsg[1] != null) {
        Message({
          message: errMsg[1].message,
          type: "error",
          offset: 60
        });
      }

      if (errMsg[2] != null) {
        Message({
          message: errMsg[2].message,
          type: "error",
          offset: 100
        });
      }
    },

    validate() {
      return this.$refs.form.validate().then(res => {
        if (!res) {
          this.showMessage();
          return;
        }

        if (this.cont_File.fileList.length < 1) {
          document.getElementById("agt_step2_contrFileUpl").focus();
          Message({
            message: "중개계약서를 업로드 해주세요.",
            type: "error"
          });
          return;
        }
        this.$emit("on-validated", res);
        this.scrollToTop();
        this.saveStep2Info();
        return res;
      });
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    addressPop() {
      var pop2 = window.open(
        "./extension/juso.html",
        "pop_basic2",
        "width=450,height=550,scrollbars=yes,resizable=yes"
      );
      // pop2.test = this.clientAddr;
    },

    //======================================== 파일 업로드 메소드들

    // 파일첨부시(업로드x) 이벤트
    uploadChange: function(file, fileList) {
      console.log("fileList: ", fileList);
      this.cont_File.fileList = fileList;
      this.cont_File.fileList.forEach(file => {
        if (file.size > 50 * 1000 * 1000) {
          Message.error("50MB이상 파일은 업로드할 수 없습니다.");
          this.cont_File.fileList.splice(
            this.cont_File.fileList.indexOf(file),
            1
          );
          return;
        }
      });
    },
    // 선택한 파일 삭제
    removeFile: function(file, fileList) {
      this.cont_File.fileList = fileList;
      // 삭제하는 파일의 raw 객체가 없다면, 그것은 이미 db에 존재하는 파일임. 이파일들의 id를 따로 모아서 파일삭제 api호출할 때 data로 집어넣음.
      console.log(file);
      if (file.raw === undefined) this.cont_File.removedIdArr.push(file.id); // DB에 존재하는 파일은 id가 존재함.
    },
    // 지정한 파일갯수를 초과해서 첨부했을 때
    exceedFileLimit: function() {
      Message.warning("파일첨부는 1개만 가능합니다.");
    }
  }
};
</script>
<style>
div.jvo-upload div.el-upload.el-upload--text {
  width: 100%;
}
div.jvo-upload div.el-upload.el-upload--text div.el-upload-dragger {
  width: 100%;
}
</style>
